import React, {Component} from "react";
import StompClient from "react-stomp-client";
import { Spinner } from "react-bootstrap";
import MonitorMeter from "../../../components/MonitorMeter";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import { withNamespaces } from "react-i18next";
import { networkDeviceActions } from "../../../actions/network-device.actions";
import { connect } from "react-redux";
import { mqttSender, sendStartCommand, sendStopCommand } from "../../../helpers/mqtt-sender";

class NetworkDeviceMonitorPage extends Component {

    rabbit = null;

    state = {
        latestMessage: null,
        model: null,
        loading: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        const id = this.props.match.params.id;
        dispatch(networkDeviceActions.getNetworkDeviceById(id))
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.singleDevice !== this.props.singleDevice && this.props.singleDevice) {
            mqttSender(sendStartCommand(this.props.singleDevice));
        }
    }

    componentWillUnmount() {
        const { singleDevice } = this.props;
        mqttSender(sendStopCommand(singleDevice));
    }

    handleMessage = (stompMessage) => {
        this.setState({
            latestMessage: stompMessage,
            model: JSON.parse(stompMessage.body),
            loading: true
        });
    };

    render() {
        const { t, singleDevice } = this.props;
        const { model } = this.state;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device'},
            { value: 'network-device-monitor', path: '#'}
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('network-device-monitor') }</h4>

                {singleDevice ? (
                    <StompClient
                        endpoint={`ws://${window.location.hostname}:15674/ws`}
                        topic={ "exchange/monitor_out/" + singleDevice.label }
                        onMessage={this.handleMessage}
                    >
                        { model ? (
                            <div className="row">
                                { model.CPUs.map((item, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('cpu')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <div className="center">
                                                            <MonitorMeter
                                                                type="percent"
                                                                unit="%"
                                                                max={100}
                                                                label={t('processor-usage')}
                                                                value={Math.floor(item.CoreLoadsAvg)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('cpu')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <MonitorMeter
                                                            type="temp"
                                                            unit="C"
                                                            max={100}
                                                            label={t("processor-temp")}
                                                            value={Math.floor(item.CoreTempsAvg)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                })}

                                { model.GPUs.map((item, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('gpu')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <div className="center">
                                                            <MonitorMeter
                                                                type="percent"
                                                                unit="%"
                                                                max={100}
                                                                label={t('processor-gpu-usage')}
                                                                value={Math.floor(item.GPULoad)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                })}

                                { model.RAMs.map((item, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('ram')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <div className="center">
                                                            <MonitorMeter
                                                                type="percent"
                                                                unit="%"
                                                                max={100}
                                                                label={t("memory-usage")}
                                                                value={Math.floor(item.LoadMemory)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('ram')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <MonitorMeter
                                                                type="other"
                                                                unit="MB"
                                                                max={item.TotalMemory}
                                                                label={t('free-memory')}
                                                                value={Math.floor(item.FreeMemory)}
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}

                                { model.HDDs.map((item, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('hdd')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <div className="center">
                                                            <MonitorMeter
                                                                type="percent"
                                                                unit="%"
                                                                max={100}
                                                                label={t('hdd-usage')}
                                                                value={Math.floor(item.HddUsage)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('hdd')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <MonitorMeter
                                                            type="temp"
                                                            unit="C"
                                                            max={100}
                                                            label={t('hdd-temp')}
                                                            value={Math.floor(item.HddTemp)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-lg-4 col-md-6">
                                                <div className="card my-3">
                                                    <div className="card-body">
                                                        <small className="gauge-text-small">{t('hdd')}</small>
                                                        <h6 className="gauge-title">{item.Name}</h6>
                                                        <MonitorMeter
                                                            type="percent"
                                                            unit="%"
                                                            max={100}
                                                            label={t('hdd-activity')}
                                                            value={Math.floor(item.HddActivity)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                        ) : (
                            <h4>{t("translation:monitor-no-data")}</h4>
                        ) }
                    </StompClient>
                ) : ((
                    <Spinner animation={"border"} />
                ))}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { singleDevice } = state.networkDeviceReducer;
    return {
        singleDevice
    };
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceMonitorPage));
